<template>
    <div class="flexContainer full">
        <section id="planos" class="flexContainer fd-c full t-fd-r t-fw-nw">
            <section class="planosWrapper flexContainer jc-sb mobileNot">
                <aside class="statusBar size1of4 flexContainer fd-c">
                    <ul>
                        <li class="ff-medium flexContainer jc-sb t-fd-c t-jc-c" id="titleFilters">
                            {{ $t("planoList.planogram") }}
                            <button @click="clearFilters" class="btnExp fright rel iBlock pointer clear mobileNot txtCenter">
                                {{ $t("catalogue.clear") }}
                            </button>
                        </li>
                        <router-link
                            v-for="st in allStatus"
                            id="typeOfSector"
                            :to="{ name: 'Planos', query: getLinkParams({ status: st.key, archived: 'all' }) }"
                            v-on:click.native="recupAction('all');"
                            class="filtersBtn pointer full ff-medium"
                            tag="li"
                            :key="st.key"
                        >
                            {{ st.trans[$t("trad")] }} <span class="fright">{{ st.nbItem }}</span>
                        </router-link>
                    </ul>

                    <div style="margin-top: 30px">
                        <b-dropdown
                            id="ddown1"
                            class="dropStatus"
                            :text="'Archive ' + (!recupActionData[getCurrentLang()] ? '' : ': ' + recupActionData[getCurrentLang()])"
                        >
                            <b-dropdown-item v-b-modal="'defaultModal'" class="dropStatus-btn">
                                <router-link
                                    v-for="action in actionArchived"
                                    v-on:click.native="recupAction(action.status);"
                                    :to="{ name: 'Planos', query: getLinkParams({ archived: action.status }) }"
                                    class="filtersBtn pointer full ff-medium"
                                    tag="li"
                                    :key="action.status"
                                    >{{ action.label[getCurrentLang()] }}</router-link
                                >
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </aside>
                <section class="searchResultsWrapper size3of4 flexContainer fd-c tabletNot">
                    <header class="queryWrapper flexContainer fd-c">
                        <div class="flexContainer ai-c jc-sb">
                            <div class="flexContainer ai-c jc-sb">
                                <router-link
                                    to="/template-plano"
                                    tag="span"
                                    class="btnExp iBlock pointer mobileNot txtCenter active"
                                    v-if="hasAccessCreate('plano_builder')"
                                    >{{ $t("plano.create") }}</router-link
                                >
                            </div>
                        </div>
                        <hr class="full mt10 separator" />
                        <div id="planoFilters" class="flexContainer jc-sb fw-w mt10">
                            <div class="filter flexContainer">
                                <div>{{ $t("plano.select_campaign_label") }}</div>
                                <select id="camapign_list" class="rel" @change="selectCampaign" v-model="selectedCampaignId">
                                    <option :value="0" class="txtCenter">{{ $t("plano.select_campaign_ele") }}</option>
                                    <option v-for="campaign in campaigns" :value="campaign.id" :key="campaign.id">{{ campaign.name }}</option>
                                </select>
                            </div>

                            <div class="filter flexContainer">
                                <div>{{ $t("plano.select_zone_label") }}</div>
                                <select id="zone_list" class="uppercase rel" @change="selectZone" v-model="selectedZoneId">
                                    <option v-for="zone in zones" :value="zone.id" :key="zone.id" class="capitalize">{{ zone.name }}</option>
                                </select>
                            </div>

                            <div class="filter flexContainer">
                                <div>{{ $t("plano.select_height_label") }}</div>
                                <select id="height_list" class="rel" @change="selectHeight" v-model="selectedHeight">
                                    <option :value="undefined">{{ $t("plano.select_height_ele") }}</option>
                                    <option v-for="size in getSize().heightFilters" :value="size.height" :key="size.height">{{ size.height }}</option>
                                </select>
                            </div>
                            <div class="filter flexContainer">
                                <div>{{ $t("plano.select_width_label") }}</div>
                                <select id="width_list" class="rel" @change="selectWidth" v-model="selectedWidth">
                                    <option :value="undefined">{{ $t("plano.select_width_ele") }}</option>
                                    <option v-for="size in getSize().widthFilters" :key="size.width">{{ size.width }}</option>
                                </select>
                            </div>

                            <div class="filter flexContainer">
                                <div>{{ $t("plano.select_stand_type_label") }}</div>
                                <select id="type_stand" class="rel" @change="selectDisplayerType" v-model="selectedDisplayerType">
                                    <option :value="undefined">---</option>
                                    <option v-for="display in displayerTypes" :value="display.id" :key="display.id">{{ display.name }}</option>
                                </select>
                            </div>

                            <div class="filter flexContainer">
                                <div>{{ $t("plano.select_sortBy_label") }}</div>
                                <select id="sort_by" class="rel" @change="selectOrder" v-model="selectedOrder">
                                    <option v-for="option in sortList" :value="option" :key="option">{{ $trad.planoList.order[option] }}</option>
                                </select>
                            </div>
                        </div>
                        <hr class="full mt10 separator" />
                    </header>
                    <section>
                        <loader :loading="loading"></loader>
                        <transition-group name="fade" class="resultsWrapper flexContainer fw-w">
                            <planoList :type="'catalog'" :key="'2'" :listPlano="searchResults"></planoList>
                        </transition-group>
                    </section>
                </section>
            </section>
            <section class="planoListMob mobileOnly">
                <div class="filters tabletOnly">
                    <hr class="full separator" />
                    <div id="planoFilters" class="flexContainer m-fd-c t-jc-sb t-fw-w mt10">
                        <div class="filter flexContainer m-fd-r">
                            <div>{{ $t("plano.select_campaign_label") }}</div>
                            <select id="camapign_list" class="rel" @change="selectCampaign" v-model="selectedCampaignId">
                                <option :value="0" class="txtCenter">{{ $t("plano.select_campaign_ele") }}</option>
                                <option v-for="campaign in campaigns" :value="campaign.id" :key="campaign.id">{{ campaign.name }}</option>
                            </select>
                        </div>
                        <div class="filter flexContainer m-fd-r">
                            <div>{{ $t("plano.select_zone_label") }}</div>
                            <select id="zone_list" class="uppercase rel" @change="selectZone" v-model="selectedZoneId">
                                <option v-for="zone in zones" :value="zone.id" :key="zone.id" class="capitalize">{{ zone.name }}</option>
                            </select>
                        </div>
                        <div class="filter flexContainer m-fd-r">
                            <div>{{ $t("plano.select_height_label") }}</div>
                            <select id="height_list" class="rel" @change="selectHeight" v-model="selectedHeight">
                                <option :value="undefined">{{ $t("plano.select_height_ele") }}</option>
                                <option v-for="size in getSize().heightFilters" :value="size.height" :key="size.height">{{ size.height }}</option>
                            </select>
                        </div>
                        <div class="filter flexContainer m-fd-r">
                            <div>{{ $t("plano.select_width_label") }}</div>
                            <select id="width_list" class="rel" @change="selectWidth" v-model="selectedWidth">
                                <option :value="undefined">{{ $t("plano.select_width_ele") }}</option>
                                <option v-for="size in getSize().widthFilters" :key="size.width">{{ size.width }}</option>
                            </select>
                        </div>
                        <div class="filter flexContainer m-fd-r">
                            <div>{{ $t("plano.select_sortBy_label") }}</div>
                            <select id="sort_by" class="rel" @change="selectOrder" v-model="selectedOrder">
                                <option v-for="option in sortList" :value="option" :key="option">{{ $trad.planoList.order[option] }}</option>
                            </select>
                        </div>
                    </div>
                    <hr class="full mt10 separator" />
                </div>
                <div class="planoMob" v-for="item in searchResults" :key="item.id">
                    <div class="headerStatus flexContainer jc-sb">
                        <div class="statusPlano uppercase" :class="renderStatus(item.status)">{{ $t("planoList." + renderStatus(item.status)) }}</div>
                        <div class="flexContainer">
                            <img class="locked" v-if="item.isLocked" src="../../assets/lock_mobile.svg" width="20" alt="lock_mobile.svg" />
                            <img @click="modalComment(item.id);" src="../../assets/comment_mobile.svg" width="20" alt="lock_mobile.svg" />
                        </div>
                    </div>
                    <div class="title flexContainer jc-sa">
                        <div class="size2of5">
                            <img src="../../../static/assets/plano.png" alt="plano" width="37" height="61" class="imgPlano center block" />
                        </div>
                        <div class="titleCampaign txtLeft uppercase size3of5">
                            <p class="planoName bold" @click="openPlano(item);">{{ item.name }}</p>
                            <h2>{{ item.campaign.name }}</h2>
                        </div>
                    </div>
                    <div class="infos center txtCenter">
                        <p><span class="hidden">4 High |</span> {{ item.width }} x {{ item.height }}</p>
                        <p>
                            <span class="ff-bold">{{ $t("planoList.modified") }}:</span> {{ item.modifiedDate }}
                        </p>
                        <p>
                            <span class="ff-bold lowercase">{{ $t("planoList.by") }}:</span> {{ item.modifiedUser.firstname }}
                            {{ item.modifiedUser.lastname }}
                        </p>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import Globals from "../globals.js";
import { mapGetters, mapActions } from "vuex";
import { bus } from "../../main";
import planoList from "../planoList/planoList";
import loader from "../loader/loader";
import campaignService from "@/services/campaign";
import displayerTypeService from "@/services/displayerType";
import TryLoadMixin from "@/mixins/TryLoadMixin";
import cacheService from "@/services/cache";

export default {
    components: {
        loader,
        planoList
    },
    mixins: [TryLoadMixin],
    data: () => ({
        dataAction: "",
        recupActionData: "",
        actionArchived: [
            {
                status: "all",
                label: {
                    fr: "Tous Planos",
                    en: "All"
                }
            },
            {
                status: "1",
                label: {
                    fr: "Archivés",
                    en: "Archived"
                }
            },
            {
                status: "0",
                label: {
                    fr: "Non archivés",
                    en: "Not archived"
                }
            }
        ],
        swiperOptionMobile: {
            direction: "horizontal",
            loop: true,
            grabCursor: true,
            setWrapperSize: true,
            autoHeight: false,
            pagination: ".swiper-pagination",
            paginationClickable: true,
            mousewheelControl: true,
            observeParents: true,
            debugger: true
        },
        rollIndex: null,
        routeParams: {},
        searchResults: [],
        status: null,
        search: "",
        allStatus: {},
        zones: [],
        displayerTypes: [],
        campaigns: [],
        selectedCampaignId: undefined,
        selectedZoneId: undefined,
        clientColor: cacheService.getLinkColor(),
        selectedHeight: undefined,
        selectedWidth: undefined,
        showModalEditName: false,
        planoToDuplicate: null,
        currentPlanoId: null,
        currentPlanoName: null,
        action: null,
        selectedOrder: "md_desc",
        selectedDisplayerType: undefined,
        sortList: ["level", "cd_asc", "md_asc", "md_desc", "camp_asc", "camp_desc", "h_asc", "h_desc", "w_asc", "w_desc"],
        idPlano: "",
        versionList: false
    }),
    watch: {
        $route(to, from) {
            if (this._.size(to.query) === 0) {
                this.clearFilters();
            }
            if (this.$route.query.offset === null) {
                this.$route.query.offset = 1;
            }
            this.updateQuery();
        }
    },
    methods: {
        ...mapActions({
            setPlanoVersion: "planos/search/setPlanoVersion",
            setPlanoName: "planos/search/setPlanoName"
        }),
        ...mapActions("campaign/list", ["populateCampaignsList"]),
        recupAction(data) {
            this.actionArchived
                .filter(v => v.status === data)
                .map(response => {
                    this.recupActionData = response.label;
                    return this.recupActionData;
                });
        },
        renderStatus(status) {
            return status === null ? "" : status.toLowerCase().replace(" ", "_");
        },
        getCurrentLang() {
            return cacheService.getUserLang();
        },
        orders(planos) {
            switch (this.selectedOrder) {
                case "cd_asc":
                    planos.sort((a, b) => {
                        let date1 = new Date(a.createdAt);
                        let date2 = new Date(b.createdAt);
                        return date1.getTime() - date2.getTime();
                    });
                    break;
                case "cd_desc":
                    planos.sort((a, b) => {
                        let date1 = new Date(a.createdAt);
                        let date2 = new Date(b.createdAt);
                        return date2.getTime() - date1.getTime();
                    });
                    break;
                case "md_asc":
                    planos.sort((a, b) => {
                        let date1 = new Date(a.modifiedDate);
                        let date2 = new Date(b.modifiedDate);
                        return date1.getTime() - date2.getTime();
                    });
                    break;
                case "md_desc":
                    planos.sort((a, b) => {
                        let date1 = new Date(a.modifiedDate);
                        let date2 = new Date(b.modifiedDate);
                        return date2.getTime() - date1.getTime();
                    });
                    break;
                case "camp_asc":
                    planos.sort((a, b) => {
                        let date1 = new Date(a.campaign.launchDate);
                        let date2 = new Date(b.campaign.launchDate);
                        return date1.getTime() - date2.getTime();
                    });
                    break;
                case "camp_desc":
                    planos.sort((a, b) => {
                        let date1 = new Date(a.campaign.launchDate);
                        let date2 = new Date(b.campaign.launchDate);
                        return date2.getTime() - date1.getTime();
                    });
                    break;
                case "h_asc":
                    planos.sort((a, b) => a.height - b.height);
                    break;
                case "h_desc":
                    planos.sort((a, b) => b.height - a.height);
                    break;
                case "w_asc":
                    planos.sort((a, b) => a.width - b.width);
                    break;
                case "w_desc":
                    planos.sort((a, b) => b.width - a.width);
                    break;
                case "level":
                    planos.sort((a, b) => (a.height - b.height) * 100000 + a.width - b.width);
                    break;
            }
            this.searchResults = planos;
        },
        selectZone() {
            this.$router.push({ name: "Planos", query: this.getLinkParams({ zone: this.selectedZoneId }) });
        },
        selectCampaign() {
            this.$router.push({ name: "Planos", query: this.getLinkParams({ campaign: this.selectedCampaignId }) });
        },
        selectHeight() {
            this.$router.push({ name: "Planos", query: this.getLinkParams({ height: this.selectedHeight }) });
        },
        selectWidth() {
            this.$router.push({ name: "Planos", query: this.getLinkParams({ width: this.selectedWidth }) });
        },
        selectOrder() {
            this.$router.push({ name: "Planos", query: this.getLinkParams({ order: this.selectedOrder }) });
            this.orders(this.getResults());
        },
        selectDisplayerType() {
            this.$router.push({ name: "Planos", query: this.getLinkParams({ displayerType: this.selectedDisplayerType }) });
        },
        setVueFilters() {
            this._.forEach(this.getFilters(), (stat, key) => {
                this.allStatus[key] = stat;
            });
        },
        getImgPath(imgPath) {
            return Globals.getBaseUrl() + imgPath;
        },
        getLinkParams(x) {
            const temp = {};

            for (let key in this.$route.query) {
                if (x[key] !== null) {
                    temp[key] = this.$route.query[key];
                }
            }
            for (let key in x) {
                if (x[key] !== null) {
                    temp[key] = x[key];
                }
            }
            return temp;
        },
        getRouteParams() {
            return this._.omitBy(this.routeParams, (o, key) => {
                return key === "offset" && o === 1;
            });
        },
        setRouteParams() {
            let params = this.$route.query;
            let temp = {};
            for (let key in params) {
                if (key !== "url" && key !== "method") {
                    temp[key] = params[key];
                } else if (key === "status") {
                }
            }
            this.routeParams = temp;
        },
        async updateQuery() {
            this.loading = true;
            this.setRouteParams();
            this.updateCNBI();
            await this.$store.dispatch("planos/search/getResults", { routeParams: this.getRouteParams() });
            this.orders(this.getResults());
            this.loading = false;
        },
        updateCNBI() {
            this.$store.dispatch("planos/filters/populate", { routeParams: this.getRouteParams() }).then(() => {
                this.setVueFilters();
                this.$forceUpdate();
            });
        },
        updateVueResults(datas) {
            this.orders(datas);
        },
        isActive(object) {
            if (typeof object.offset !== "undefined") {
                let params = this.getRouteParams();
                if (typeof params.offset !== "undefined" && params.offset > 1) {
                    if (parseInt(params.offset) === parseInt(object.offset)) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    if (parseInt(object.offset) === 1) {
                        return true;
                    }
                }
            } else {
                return object.active;
            }
        },
        firstLoadToggleActive() {
            this.$store.dispatch("planos/filters/populate", { routeParams: this.getRouteParams() }).then(() => {
                this._.forEach(this.getRouteParams(), (param, key) => {
                    if (key === "search") {
                        bus.$emit("updateSearch", this.getRouteParams().search);
                    }
                });
            });
        },
        clearFilters() {
            this.$router.replace("/planos?campaign=" + 0);
            this.selectedCampaignId = 0;
            this.selectedHeight = undefined;
            this.selectedWidth = undefined;
            this.selectedDisplayerType = null;
            this.recupActionData = "";
        },
        filtersLoaded() {
            let params = {};
            params.routeParams = {};
            if (this._.size(this.getRouteParams())) {
                params.routeParams = this.getRouteParams();
            }
            this.firstLoadToggleActive();

            this.$store.dispatch("planos/search/getResults", params).then(response => {
                this.orders(this.getResults());
            });
        }
    },
    computed: {
        ...mapGetters("brand/", ["getLinksColor"]),
        ...mapGetters("planos/filters/", ["getFilters", "getLength", "getSize"]),
        ...mapGetters("planos/search/", ["getResults", "getResultsLength", "getMetaTotal", "getMetaTotalPage"]),
        ...mapGetters("currentUser/", ["currentUser"])
    },
    async created() {
        const [displayerTypes] = await Promise.all([displayerTypeService.get()]);
        this.displayerTypes = displayerTypes.data;
        this.selectedZoneId = this.currentUser.zoneId;
        this.selectedCampaignId = this.currentUser.campaignId;
        this.setRouteParams();
        bus.$on("resetSearch", this.clearFilters);
        bus.$on("filters_loaded", this.filtersLoaded);
        this.$store.dispatch("planos/filters/populate", { routeParams: {} }).then(() => {
            this.setVueFilters();
            this.filtersLoaded();
        });
        this.$route.query.offset = 1;
        const currentBrand = this.currentUser.user.brands.find(brand => brand.id == this.currentUser.brandId);
        this.zones = (currentBrand && currentBrand.zones) || [];
        this.campaigns = currentBrand.campaigns;
        this.$store.dispatch("planos/filters/getSize");
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";
.btnExp {
    @extend %second-border;
    @extend %primary-text;
}
#planos {
    margin-top: 10px;
    .statusBar {
        @extend %primary-bloc;
        ul {
            @extend %primary-background;
            padding: 0px;
            margin: 0;
            li {
                list-style: none;
                margin: 0;
                text-transform: uppercase;
                &.active {
                    transition: 0.2s;
                    @extend %second-background;
                    @extend %primary-text;
                }
                &#titleFilters {
                    font-size: 18px;
                    font-family: Roboto;
                    @extend %primary-text;
                    padding: 20px 30px;
                    .clear {
                        text-decoration: none;
                        @extend %primary-text;
                        top: -5px;
                        &:hover {
                            @extend %primary-text;
                        }
                    }
                }
                &.filtersBtn {
                    font-size: 1.4rem;
                    color: #999;
                    padding: 20px;
                    border-bottom: 1px solid #c6c6c6;
                    width: 90%;
                    margin-left: 5%;
                    &:hover {
                        transition: 0.2s;
                        @extend %second-background;
                        @extend %primary-text;
                    }
                }
            }
        }
    }
    .searchResultsWrapper {
        margin: 0 10px;
        @extend %primary-bloc;
        border-radius: 3px;
        padding: 30px;
        #planoFilters {
            font-size: 14px;
            .filter {
                font-size: 14px;
                padding: 10px 0px;
                font-weight: 500;
                @extend %primary-text;
                &:first-child {
                    padding-left: 0;
                }
                &:last-child {
                    padding-right: 0;
                }
                &.abs {
                    right: 0;
                }
                select {
                    border: none;
                    font-weight: 300;
                    bottom: 2px;
                    margin-left: 5px;
                    @extend %second-text;
                    @extend %primary-background;
                }
            }
        }
        .resultsWrapper {
            padding-top: 30px;
            .item {
                font-size: 1.4rem;
                background: #f4f4f4;
                margin-bottom: 20px;
                .contextMenu {
                    background-color: darkgrey;
                    width: 92px;
                }
                .status {
                    padding: 5px;
                    min-width: 85px;
                }
            }
        }
        #searchInputPlanos {
            height: 30px;
            border-left: none;
            border-top: none;
            border-right: none;
            font-size: 14px;
        }
        .separator {
            border-top: none;
            border-left: none;
            border-right: none;
            @extend %second-border-color;
        }
    }
}

.pagination {
    .pageLink {
        font-size: 1.6rem;
        width: 20px;
        height: 20px;
        margin: 0 2px;
        text-align: center;
        text-decoration: none;
        color: #343434;
        &:hover {
            color: #343434;
        }
        &.active {
            color: rgb(200, 0, 0);
            font-weight: 700;
        }
    }
}

#optionsList {
    background-color: #f4f4f4;
    padding: 0.65rem 1.7rem;
}

@media only screen and (max-width: 767px) {
    .planoListMob {
        margin-top: 30px;
        .separator {
            border-top: none;
            border-left: none;
            border-right: none;
            border-color: #ccc;
        }
    }
    .planoMob {
        background-color: white;
        width: inherit;
        margin-bottom: 25px;
        padding: 10px;
    }
    #planoFilters {
        .filter {
            &:last-child {
                div {
                    width: 17%;
                }
            }
        }
        select {
            width: 100%;
            position: relative;
            bottom: 3px;
        }
    }
    .title {
        margin: 0px 15px 30px 15px;
        figure {
            height: 200px;
            max-width: 100%;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
        }
        h3 {
            font-size: 1.4rem;
        }
    }
    .imgPlano {
        margin-top: 18px;
    }
    .titleCampaign {
        margin-top: 4px;
    }
    .infos {
        padding-bottom: 15px;
        p {
            font-size: 1.4rem;
        }
    }
    .headerStatus {
        height: 30px;
        .statusPlano {
            margin-top: auto;
            margin-bottom: auto;
        }
        .locked {
            margin-right: 5px;
        }
    }
    .planoName {
        font-size: 17px;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1024px) {
    #planos {
        .statusBar {
            width: 100%;
            padding: 0 15px;
            ul {
                li {
                    &#titleFilters {
                        font-size: 1.4rem;
                        padding-left: 0;
                        padding-right: 0;
                        text-align: center;
                        display: block;
                        .clear {
                            top: initial;
                            right: initial;
                            width: 100px;
                            margin: auto;
                            margin-top: 15px;
                            font-size: 1.1rem;
                            float: none;
                        }
                    }
                    &.filtersBtn {
                        font-size: 1.2rem;
                        text-align: center;
                        padding: 15px 0;
                        span {
                            float: none;
                        }
                    }
                }
            }
        }
        #planoFilters {
            font-size: 1.1rem;
        }
        .planoListMob {
            width: 100%;
            margin-left: 20px;
            select {
                position: relative;
                bottom: 3px;
            }
            .separator {
                border-top: none;
                border-left: none;
                border-right: none;
                border-color: #ddd;
                &:last-child {
                    margin-bottom: 20px;
                }
            }
            .planoMob {
                background-color: #fff;
                width: inherit;
                margin-bottom: 25px;
                padding: 10px;
                font-size: 1.4rem;
                .headerStatus {
                    height: 30px;
                    .statusPlano {
                        margin-top: auto;
                        margin-bottom: auto;
                    }
                    .locked {
                        margin-right: 5px;
                    }
                }
                .planoName {
                    font-size: 1.8rem;
                    margin-top: 0;
                }
                h2 {
                    margin-bottom: 0;
                }
            }
            .title {
                margin-bottom: 15px;
            }
            .infos {
                padding: 0;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Planos.vue?29d54a80